import {
  defaultGetSectionComponent,
  defaultGetQuestionComponent
} from 'dpl/quiz/utils';

import * as SECTION_COMPONENTS from '../components/sections';

export function getSectionComponent(section) {
  return (
    SECTION_COMPONENTS[section.component_name] ||
    defaultGetSectionComponent(section)
  );
}
export function getQuestionComponent(question) {
  return defaultGetQuestionComponent(question);
}
